import React from 'react';
import { Controller } from 'react-hook-form';

import { DropzoneFileUrlFieldRequiredProps } from './DropzoneFileUrlField.types';

import {
  DropzoneFileUrlFieldControl,
  DropzoneFileUrlFieldControlRequiredProps
} from './components/DropzoneFileUrlFieldControl';

function DropzoneFileUrlField<T>({
  accept,
  control,
  disabled,
  error,
  maxSize,
  name,
  rules,
  type
}: DropzoneFileUrlFieldRequiredProps<T> &
  DropzoneFileUrlFieldControlRequiredProps) {
  return (
    <Controller
      control={control}
      rules={rules}
      name={name}
      render={({ field: { onChange }, fieldState: { error: fieldError } }) => (
        <DropzoneFileUrlFieldControl
          accept={accept}
          disabled={disabled}
          error={fieldError?.message || error}
          onChange={onChange}
          maxSize={maxSize}
          type={type}
        />
      )}
    />
  );
}

export default DropzoneFileUrlField;
